/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ free_trial_day: NonNullable<unknown>, monthly_price: NonNullable<unknown> }} Subscription_Footer_Monthly_Free_TrialInputs */

const en_subscription_footer_monthly_free_trial = /** @type {(inputs: Subscription_Footer_Monthly_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Free trial for ${i?.free_trial_day} days, then ${i?.monthly_price} per month, cancel anytime.`)
};

const ar_subscription_footer_monthly_free_trial = /** @type {(inputs: Subscription_Footer_Monthly_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تجربة مجانية لمدة ${i?.free_trial_day} يومًا، ثم ${i?.monthly_price} شهريًا، يمكنك الإلغاء في أي وقت.`)
};

const de_subscription_footer_monthly_free_trial = /** @type {(inputs: Subscription_Footer_Monthly_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kostenlose Testversion für ${i?.free_trial_day} Tage, dann ${i?.monthly_price} pro Monat, jederzeit kündbar.`)
};

const es_subscription_footer_monthly_free_trial = /** @type {(inputs: Subscription_Footer_Monthly_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prueba gratuita durante ${i?.free_trial_day} días, luego ${i?.monthly_price} al mes, cancelación en cualquier momento.`)
};

const fr_subscription_footer_monthly_free_trial = /** @type {(inputs: Subscription_Footer_Monthly_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Essai gratuit pendant ${i?.free_trial_day} jours, puis ${i?.monthly_price} par mois, résiliable à tout moment.`)
};

const it_subscription_footer_monthly_free_trial = /** @type {(inputs: Subscription_Footer_Monthly_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prova gratuita per ${i?.free_trial_day} giorni, poi ${i?.monthly_price} al mese, annulla in qualsiasi momento.`)
};

const ja_subscription_footer_monthly_free_trial = /** @type {(inputs: Subscription_Footer_Monthly_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day}日間の無料トライアル、その後は${i?.monthly_price}/月、いつでもキャンセル可能です。`)
};

const ko_subscription_footer_monthly_free_trial = /** @type {(inputs: Subscription_Footer_Monthly_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day}일 동안 무료 체험 후 매월 ${i?.monthly_price}에 이용할 수 있으며 언제든지 취소할 수 있어요.`)
};

const pt_br_subscription_footer_monthly_free_trial = /** @type {(inputs: Subscription_Footer_Monthly_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teste grátis por ${i?.free_trial_day} dias, então ${i?.monthly_price} por mês. Cancele a qualquer momento.`)
};

const ru_subscription_footer_monthly_free_trial = /** @type {(inputs: Subscription_Footer_Monthly_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Бесплатная пробная версия на ${i?.free_trial_day} дней, затем ${i?.monthly_price} в месяц, отмена в любое время.`)
};

const th_subscription_footer_monthly_free_trial = /** @type {(inputs: Subscription_Footer_Monthly_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`การทดลองใช้ฟรี ${i?.free_trial_day} วัน หลังจากนั้น ${i?.monthly_price} ต่อเดือน ยกเลิกได้ตลอดเวลา`)
};

const tr_subscription_footer_monthly_free_trial = /** @type {(inputs: Subscription_Footer_Monthly_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day} gün boyunca ücretsiz deneme, ardından aylık ${i?.monthly_price}, istediğin zaman iptal edebilirsin.`)
};

const zh_cn_subscription_footer_monthly_free_trial = /** @type {(inputs: Subscription_Footer_Monthly_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免费试用 ${i?.free_trial_day} 天后，每月 ${i?.monthly_price}，随时可以取消。`)
};

const zh_tw_subscription_footer_monthly_free_trial = /** @type {(inputs: Subscription_Footer_Monthly_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免費試用 ${i?.free_trial_day} 天後，每月 ${i?.monthly_price}，隨時可以取消。`)
};

/**
* | output |
* | --- |
* | "Free trial for {free_trial_day} days, then {monthly_price} per month, cancel anytime." |
*
* @param {Subscription_Footer_Monthly_Free_TrialInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_footer_monthly_free_trial = /** @type {((inputs: Subscription_Footer_Monthly_Free_TrialInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Footer_Monthly_Free_TrialInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_footer_monthly_free_trial(inputs)
	if (locale === "ar") return ar_subscription_footer_monthly_free_trial(inputs)
	if (locale === "de") return de_subscription_footer_monthly_free_trial(inputs)
	if (locale === "es") return es_subscription_footer_monthly_free_trial(inputs)
	if (locale === "fr") return fr_subscription_footer_monthly_free_trial(inputs)
	if (locale === "it") return it_subscription_footer_monthly_free_trial(inputs)
	if (locale === "ja") return ja_subscription_footer_monthly_free_trial(inputs)
	if (locale === "ko") return ko_subscription_footer_monthly_free_trial(inputs)
	if (locale === "pt_br") return pt_br_subscription_footer_monthly_free_trial(inputs)
	if (locale === "ru") return ru_subscription_footer_monthly_free_trial(inputs)
	if (locale === "th") return th_subscription_footer_monthly_free_trial(inputs)
	if (locale === "tr") return tr_subscription_footer_monthly_free_trial(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_footer_monthly_free_trial(inputs)
	return zh_tw_subscription_footer_monthly_free_trial(inputs)
});